import { useProjectSharedState } from "./useSharedState";
import { ApiProject, ApiReportResponse } from "@incendium/api";
import { reportService } from "Apis";

const fetchReports = async (selectedProject: ApiProject) => {
  if (selectedProject) {
    const reports = await reportService.reportServiceListReports({
      projectId: selectedProject.id as number,
    });
    return reports.results || [];
  }
  return [];
};

export const useReports = () => {
  const { state, setState, refetch, fetched } = useProjectSharedState(
    "reports",
    [],
    fetchReports
  );

  return {
    reports: state as ApiReportResponse[],
    setReports: setState,
    refetchReports: refetch,
    fetched
  };
};
